export default function Pricing() {
  const plans = [
    {
      name: 'Mise en place',
      price: '4 000 €',
      priceSuffix: '– 8 000 €',
      type: 'Paiement facile',
      description: 'Votre système d\'acquisition clé en main, opérationnel en 30 jours.',
      features: [
        'Audit & stratégie personnalisée',
        'Tunnels, landing pages & automatisations',
        'Intégration complète des outils',
        '3 mois de support inclus',
      ],
      highlight: false,
      icon: 'ri-rocket-line',
      badge: 'Démarrage',
      cta: 'Démarrer mon projet',
    },
    {
      name: 'Suivi & Optimisation',
      price: '300 €',
      priceSuffix: '– 900 €/mois',
      type: 'Sans engagement',
      description: 'On pilote, on optimise, on scale — vous vous concentrez sur vos clients.',
      features: [
        'Optimisation des campagnes',
        'Séquences emails, alertes',
        'Reporting mensuel & veille',
        'Support ticket illimité',
      ],
      highlight: true,
      icon: 'ri-line-chart-line',
      badge: 'Recommandé',
      cta: 'Obtenir un devis',
    },
  ];

  const reassurances = [
    { icon: 'ri-calendar-check-line', label: 'Sans engagement', sub: 'Résiliez à tout moment' },
    { icon: 'ri-money-euro-circle-line', label: 'Paiement flexible', sub: 'Plusieurs fois possible' },
    { icon: 'ri-shield-check-line', label: 'Garantie résultats', sub: '3 mois offerts si insatisfait' },
  ];

  return (
    <section className="py-20 sm:py-28 bg-white overflow-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-orange-500 font-semibold text-sm uppercase tracking-widest mb-3">Tarifs</span>
          <h2 className="text-3xl sm:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            Un investissement qui se rentabilise
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Deux formules simples pour remplir votre agenda
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-3xl p-8 flex flex-col gap-6 transition-all duration-300 ${
                plan.highlight
                  ? 'bg-gray-900 text-white shadow-2xl md:scale-105'
                  : 'bg-white border-2 border-gray-100 shadow-md hover:shadow-xl'
              }`}
            >
              {/* Badge */}
              <span className={`absolute -top-4 left-8 px-4 py-1.5 rounded-full text-xs font-bold whitespace-nowrap ${
                plan.highlight ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-600'
              }`}>
                {plan.badge}
              </span>

              {/* Top */}
              <div className="flex items-center gap-4 pt-2">
                <div className={`w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0 ${
                  plan.highlight ? 'bg-white/10' : 'bg-orange-50'
                }`}>
                  <i className={`${plan.icon} text-2xl ${plan.highlight ? 'text-orange-400' : 'text-orange-500'}`}></i>
                </div>
                <div>
                  <h3 className={`text-lg font-bold ${plan.highlight ? 'text-white' : 'text-gray-900'}`}>{plan.name}</h3>
                  <span className={`text-xs font-medium ${plan.highlight ? 'text-white/50' : 'text-gray-400'}`}>{plan.type}</span>
                </div>
              </div>

              {/* Price */}
              <div>
                <div className={`text-4xl font-extrabold ${plan.highlight ? 'text-white' : 'text-gray-900'}`}>
                  {plan.price}
                </div>
                <p className={`mt-2 text-sm leading-relaxed ${plan.highlight ? 'text-white/70' : 'text-gray-500'}`}>
                  {plan.description}
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-2.5 flex-1">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2.5 text-sm">
                    <i className={`ri-check-line text-base flex-shrink-0 ${plan.highlight ? 'text-orange-400' : 'text-orange-500'}`}></i>
                    <span className={plan.highlight ? 'text-white/80' : 'text-gray-700'}>{f}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button
                data-iclosed-link="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
                data-embed-type="popup"
                className={`w-full py-3.5 rounded-xl font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  plan.highlight
                    ? 'bg-orange-500 text-white hover:bg-orange-400'
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>

        {/* Reassurances */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 max-w-3xl mx-auto">
          {reassurances.map((r, i) => (
            <div key={i} className="flex items-center gap-3 bg-gray-50 rounded-2xl px-5 py-4 flex-1">
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${r.icon} text-xl text-orange-500`}></i>
              </div>
              <div>
                <div className="text-sm font-bold text-gray-900">{r.label}</div>
                <div className="text-xs text-gray-500">{r.sub}</div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
